module.exports = __webpack_public_path__ + "img/EditorSS1.b3d2ecba.gif";